/* eslint-disable no-extra-semi */
import React from 'react'
import Appsignal from '@appsignal/javascript'
import { ErrorBoundary } from '@appsignal/react'

const CLARITYID = process.env.REACT_APP_CLARITY || ''
const GTMID = process.env.REACT_APP_GTM || ''
const APPSIGNALID = process.env.REACT_APP_APPSIGNAL || ''

export function addClarity() {
  if (CLARITYID.length) {
    ;(function(c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function() {
          ;(c[a].q = c[a].q || []).push(arguments)
        }
      t = l.createElement(r)
      t.async = 1
      t.src = 'https://www.clarity.ms/tag/' + i
      y = l.getElementsByTagName(r)[0]
      y?.parentNode?.insertBefore && y.parentNode.insertBefore(t, y)
    })(window, document, 'clarity', 'script', CLARITYID)
    return true
  }
  return false
}

export function addGoogleTagManager() {
  if (GTMID.length) {
    ;(function(w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer', GTMID)
    return true
  }
  return false
}

export const appsignal = APPSIGNALID.length ? new Appsignal({ key: APPSIGNALID }) : {}

export const AppSignalBoundary = ({ children }) => {
  if (APPSIGNALID.length) {
    return <ErrorBoundary instance={appsignal}>{children}</ErrorBoundary>
  }
  return children
}
